import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import { esWB_ScnConstraint } from "../PA.Core/PAdbSchema";

const vUI_ScenarioConstraint_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SCNCONSTRAINTM_ID:      {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Id',              alignment: HorizAlignment.Left},  domainOptions: {} },
    CONSTRAINT_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Constraint Id',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CONSTRAINT_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Constraint Name',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    CONSTRAINT_TYPE:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Constraint Type',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:                  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Comments',           alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    SETTINGS_TEMPLATE:         {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Settings Template',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 500}},
    METRIC_ID:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Metric',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},

};

const ScenarioConstraintSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_SCNCONSTRAINTM_ID',
        id_ui: 'CONSTRAINT_ID',
        name:  'CONSTRAINT_NAME'
    },

    searchProviderFields: vUI_ScenarioConstraint_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                esWB_ScnConstraint,
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ScenarioConstraintSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ScenarioConstraintSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'CONSTRAINT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'CONSTRAINT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'CONSTRAINT_ID', 'CONSTRAINT_NAME',
        'CONSTRAINT_TYPE', 'COMMENTS', 'SETTINGS_TEMPLATE', 'METRIC_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ScenarioConstraintSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const ScenarioConstraintSearch: ISearch = {
    searchName: "Find Scenario Constraint",
    renderOptions: {ui5ResourceId: "ScenarioConstraintSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ScenarioConstraintSearchProfileByName]
};


export {ScenarioConstraintSearch}

